<template>
  <div class="AppLayout">
    <app-head :title="$page.props?.meta_title || title" />
    
    <app-download-banner />

    <jet-banner />

    <app-header class="relative z-30" />

    <main class="relative z-20 -mt-gr-double-6 sm:-mt-gr-double-7">
      <slot v-bind="$attrs"></slot>
    </main>

    <app-footer class="mt-gr-9" />

    <!-- <add-to-home-screen v-if="showBanner" /> -->
  </div>
</template>

<script>
  import AppDownloadBanner from '@/Components/AppDownloadBanner';
  import AppHeader from '@/Components/AppHeader';
  import AppHead from '@/Components/AppHead';
  import AppFooter from '@/Components/AppFooter';
  import JetBanner from '@/Jetstream/Banner';
  import AddToHomeScreen from '@/Components/AddToHomeScreen';

  const showOnRoutes = ['listen.promo.view', 'library'];

  export default {
    name: 'AppLayout',

    components: {
      AppDownloadBanner,
      AppHeader,
      AppHead,
      AppFooter,
      JetBanner,
      AddToHomeScreen,
    },

    props: {
      title: {
        type: String,
        default: 'ONE Audiobooks',
      },
    },

    data() {
      return {
        showBanner: showOnRoutes.indexOf(route().current()) !== -1,
      };
    },
  };
</script>

<!-- <style lang="scss" src="./AppLayout.scss" scoped></style> -->
